import React from 'react';

interface CardProps {
  children: React.ReactNode;
  className?: string;
  padding?: 'none' | 'sm' | 'md' | 'lg';
  hover?: boolean;
  onClick?: () => void;
}

const paddingClasses = {
  none: '',
  sm: 'p-4',
  md: 'p-6',
  lg: 'p-8',
};

export function Card({
  children,
  className = '',
  padding = 'md',
  hover = false,
  onClick,
}: CardProps): React.ReactElement {
  return (
    <div
      onClick={onClick}
      role={onClick ? 'button' : undefined}
      tabIndex={onClick ? 0 : undefined}
      className={[
        'glass-card',
        paddingClasses[padding],
        hover
          ? 'transition-all duration-200 hover:border-white/20 hover:bg-white/8 hover:-translate-y-0.5 hover:shadow-xl cursor-pointer'
          : '',
        onClick ? 'focus-visible:ring-2 focus-visible:ring-primary-500 focus-visible:outline-none' : '',
        className,
      ]
        .filter(Boolean)
        .join(' ')}
    >
      {children}
    </div>
  );
}
